import { ArrowForwardIcon } from "@chakra-ui/icons";
import React, { useRef, useState } from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import { HiVolumeUp } from "react-icons/hi"
// import 'bootstrap/dist/css/bootstrap.min.css';

const FixedMediaComponent = () => {
  const fixedStyle = {
    position: "fixed",
    maxWidth: "280px",
    bottom: "20px",
    right: "20px",
    zIndex: 1000,
    textAlign: "right", // Align content to the right
  };

  const audioRef = useRef(null);
  const [isAudioEnabled, setIsAudioEnabled] = useState(false);

  const handlePlayAudio = () => {
    if (audioRef.current) {
      audioRef.current.play();
    }
  };

  const handlePauseAudio = () => {
    if (audioRef.current) {
      audioRef.current.pause();
    }
  };

  const handleEnableAudio = () => {
    setIsAudioEnabled(true);
    if (audioRef.current) {
      audioRef.current.play();
    }
  };

  return (
    <Container>
      <div style={fixedStyle}>
        <Row
          className="align-items-center justify-content-end"
          noGutters
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "flex-end", // Align items to the right
          }}
        >
          <Col md={7} style={{ textAlign: "right" }}>
            <div style={{ position: "relative", display: "inline-block" }}>
              {!isAudioEnabled && (
                <button
                  onClick={handleEnableAudio}
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    color: "white",
                    border: "none",
                    borderRadius: "5px",
                    padding: "10px 20px",
                    cursor: "pointer",
                    zIndex: 2,
                  }}
                >
                  {/* put play icon */}
                  {/* <PlayIcon /> */}
                  {/* Enabl Audio */}
                  <HiVolumeUp/>
                  {/* <ArrowForwardIcon/> */}
                  {/* Enable Audio */}
                </button>
              )}
              <Image
                src="img/kiyg25-mascot.gif"
                alt="Sample GIF"
                fluid
                onMouseEnter={isAudioEnabled ? handlePlayAudio : null} // Play audio when hovering over GIF
                onMouseLeave={isAudioEnabled ? handlePauseAudio : null} // Pause audio when mouse leaves GIF
              />
              <audio ref={audioRef} src="img/kiyg25-mascot.mp3" loop />
            </div>
          </Col>
          <Col md={5} style={{ marginTop: "25px" }}>
            <Image src="img/kiyg25-QR.jpg" alt="Sample Image" width={"150"} />
          </Col>
        </Row>
      </div>
    </Container>
  );
};

export default FixedMediaComponent;
